export enum PARAM {
  howMany = 'howMany',
  name = 'name',
}
